import { TranslationKey } from 'utils/i18n/types'
import { keysOf } from 'utils/general'
import { captureEvent } from '@sentry/nextjs'

export const isSiteCategory = (
  value: string
): value is TranslationKey<'device', 'device.store.categories'> => {
  const categoryObj: Record<TranslationKey<'device', 'device.store.categories'>, true> = {
    top: true,
    social: true,
    shopping: true,
    media: true,
    'payment, banks and trading': true,
    'software and publishing': true,
    telecom: true,
    dating: true,
    'photo&video': true,
    crypto: true,
    'music, news and gaming': true,
  }
  const categories = keysOf(categoryObj)
  if (categories.some((cat) => cat === value)) {
    return true
  } else {
    captureEvent({
      message: `Site category not found: ${value}`,
      level: 'warning',
    })
    return false
  }
}
